import React, { useEffect, useState } from 'react';
import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import ChildHeader from '../../../components/ui/ChildHeader';
import { PersitedDatePicker, TableCustom } from '../../../components/common';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from '../processRejection/helpers/interface';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../services/auth/AuthProvider';
import { getDailyProductionYearly } from '../processRejection/helpers/utils';
import { EditIconButton } from '../../../components/common/button/CustomIconButton';

const Header = [
  [
    {
      text: '#',
      colspan: 1,
      rowspan: 1,
    },

    {
      text: 'MONTH & YEAR',
      colspan: 1,
      rowspan: 1,
    },
    {
      text: 'ACTION',
      colspan: 1,
      rowspan: 1,
    },
  ],
];

const List = () => {
  const [monitoringList, setMoniteringList] = useState<
    { month_year: string }[]
  >([]);
  const { state } = useAuth();
  const heading = useQuery('heading') || '';
  const date = useQuery('date');
  const navigate = useNavigate();
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE CUSTOMER',
    'Are you sure you want to delete this document?'
  );
  useEffect(() => {
    let data = getDailyProductionYearly(date);
    setMoniteringList(data);
  }, [date]);
  return (
    <>
      <ChildHeader text={heading}></ChildHeader>
      <div style={{ display: 'flex', margin: '1rem' }}>
        <Box sx={{ margin: 2 }}>
          <PersitedDatePicker label="Year" views={['year']} />
        </Box>
      </div>
      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {monitoringList.map((item: any, index) => (
            <React.Fragment>
              <TableRow>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{item.month_year}</TableCell>
                <TableCell align="center">
                  <EditIconButton
                    tooltipTitle="edit"
                    onClick={() =>
                      navigate(
                        `/common/redBinMonitoringSheet/dashboard?annual_date=${item.month_year}`
                      )
                    }
                  />
                </TableCell>
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </TableCustom>
    </>
  );
};

export default List;
